module.exports = __webpack_public_path__ + "img/imgelizam.8956d9f6.png";